var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sys"},_vm._l((_vm.infoData),function(item,index){return _c('div',{key:index,domProps:{"innerHTML":_vm._s(item.NewsDesc)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }